import { useCallback } from "react";

import useClient from "hooks/useClient";

const useFindEstimateAttachment = (): {
  findEstimateAttachment: (estimateId: string) => Promise<Attachment>;
} => {
  const { client } = useClient();

  const findEstimateAttachment = useCallback(
    async (estimateId: string) => {
      const { data } = await client({
        method: "get",
        url: `/order/:orderId/estimate/${estimateId}/downloaded-pdf`,
      });
      return data as Attachment;
    },
    [client]
  );

  return { findEstimateAttachment };
};

export default useFindEstimateAttachment;
